// await 函数返回结果处理 每次使用不需要try catch
export const awaitFnHandle = async (fn = () => {}, ...params) => {
  try {
    let result = await fn(...params);
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};
